<div id="cluster-bar-chart-section" class="cluster-bar-chart-section"></div>